import React, { useContext } from 'react';

import { makeStyles } from 'tss-react/mui';
import DialogScrollOverlay from '../../../../../../Components/DialogScrollOverlay/DialogScrollOverlay';
import { BreadcrumbsContext } from '../../RutinBreadcrumbs/BreadcrumbsContext';

interface IProps {
  editMenuVisible: boolean;
}

const useStyles = makeStyles()(theme => ({
  overlay: {
    height: `${theme.customProperties.stepperBarHeight}px`,
    background: theme.palette.secondary.dark,
  },
  stepperContainer: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.common.white,
  },
  stepper: {},
}));

const StepperBar: React.FC<React.PropsWithChildren<IProps>> = props => {
  const { classes } = useStyles();
  const { setStepperSmallRef } = useContext(BreadcrumbsContext);

  return (
    <DialogScrollOverlay
      classes={{
        container: classes.overlay,
      }}
      disableShadow={props.editMenuVisible}
    >
      <div className={classes.stepperContainer}>
        <div
          className={classes.stepper}
          ref={node => {
            if (node != null) {
              setStepperSmallRef(node);
            }
          }}
        />
      </div>
    </DialogScrollOverlay>
  );
};

export default StepperBar;
